import { graphql } from '~/__gql__/index';

export const mutationRequestCustomAccountTypesUpsell = graphql(/* GraphQL */ `
  mutation RequestCustomAccountTypesUpsell {
    requestCustomAccountTypesUpsell
  }
`);
